/* Info component on the Create and Callsheet form
   telling users that the Add Cast and Add Background forms are 
   seperate from the main Callsheet form */
   import React from 'react';
   import Row from "react-bootstrap/Row";
   import Col from "react-bootstrap/Col";
   import styles from "../../../styles/Callsheets.module.css";
   
   const InfoCallCreate = () => {
     return (
       <div>
           <Row className="mb-3">
           <Col md={{span: 10, offset: 1}}>
           <div className={`px-3 py-3 ${styles.SubTitle6 }`}>
            <h5 className={`text-center ${styles.Red }`} >INFO</h5>  
           <p className="pt-1">
           Create the Callsheet by filling in one or more time inputs and submiting.</p>
           <p className="pt-2">
           Add all other Info from the Edit page.
             </p>
            </div> 
           </Col>
         </Row>
       </div>
     )
   }
   
   export default InfoCallCreate